/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { PaginatedResponseWithErrorGeneric } from '../shared/paginated-response-with-error-generic';
import { GetArticlesResponseJson } from './get-articles-response-json';
import { DefaultGetResult } from '../results/default-get-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { ArticleDto } from '../models/article-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetArticlesResponse extends PaginatedResponseWithErrorGeneric<GetArticlesResponseJson, DefaultGetResult> implements IResponseWithErrorGeneric<DefaultGetResult> {
  public articles: ArticleDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetArticlesResponse>) {
      super(response, DefaultGetResult.Error);
      if (this.result !== DefaultGetResult.Success) {
        return;
      }
        
      this.articles = this.body.articles;
    }
  //</custom-body>
}
